// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const FEED_DISPLAY_MORE = "Zobraz \u010fal\u0161ie";
